/*
创建者 魏强(2018.1.30)
中华老字号 优选特推
*/
<template>
	<div class="china-item">
		<h2>
			<img :src="chinaImg1" title="优选特推" />
		</h2>
        <div class="china-content-1" id="qua-swiper" :style="{background:`url(${china1Bg})`}">
            <div class="swipe" id="qua-swiper-container">
            	<Carousel
		        v-model="value"
		        :autoplay="setting.autoplay"
		        :autoplay-speed="setting.autoplaySpeed"
		        :dots="setting.dots"
		        :radius-dot="setting.radiusDot"
		        :trigger="setting.trigger"
		        :arrow="setting.arrow"
		        >
			        <CarouselItem v-for="(item,index) in list " :key="index">
			        	<div v-for="child in item" class="qua-item" style="float0:left">
							<router-link :to="{path:'/goods',query:{goods_id:child.goodsId}}">
								<img :src="child.imgUrl" :alt="child.tip"  />
					 		</router-link>
						</div>
			        </CarouselItem>
			    </Carousel>
			</div>
        </div>
    </div>
</template>
<script>
import {zhlzhGoodsYouXuan} from 'api/home';
import chinaImg1 from '../../assets/images/china/china-1.png';
import china1Bg from '../../assets/images/china/china-1-bg.png';
	export default{
		computed:{
			list:function(){
				let data = this.data;
				let list = [];
				for(let i=0;i<data.length;i++){
					let tem = []
					let index = parseInt(i/4);
					list[index]=list[index]||[];
					list[index].push(data[i]);
				}
				return list;
			}
		},
		data () {
	        return {
	        	chinaImg1,
	        	china1Bg,
	            value: 0,
	            setting: {
	                autoplay: true,
	                autoplaySpeed: 2000,
	                dots: 'none',
	                radiusDot: false,
	                trigger: 'hover',
	                arrow: 'hover'
	            },
	            pageNo:0,
				hasMore:true,
				data:[]
	        }
	    },
	    created(){
	    	//加载
			this.fetchData();
		},
		methods:{
			fetchData(){
				let pageNo = this.pageNo;
				zhlzhGoodsYouXuan(++pageNo).then(json=>{
					this.pageNo=pageNo;
					console.log(json)
					if(json.resCode==1){
						let data = json.data;
						this.hasMore = data.hasMore;
						this.data=[...this.data,...data.list];
						if(this.hasMore){
							this.fetchData();
						}
					}else{
						console.log("中华老字号-优选数据失败")
					}
				});

			}
		}
	}
</script>
<style scope>
	.qua-item{
		margin: 0;
	}
</style>



// WEBPACK FOOTER //
// optimization.vue?bb6812b4